<style src="./Datebox.scss" lang="scss" scoped></style>
<template lang="html">
  <label
    class="cp1-textbox"
    :class="{'valid-fail': !isValid}">

    <label class="label">
      <span class="caption">{{ label }}</span>
      <input
        type="date"
        class="cp1-small-textbox textbox"
        v-model="inputValue"
        :placeholder="placeholder"
        @blur="runValidation"
        :autofocus="autofocus"
        :disabled="disabled" />
    </label>
  </label>
</template>

<script>
import ValidationMixin from '@/components/primitives/validator/validation-mixin/ValidationMixin.js'

export default {
  name: 'Datebox',
  mixins: [
    ValidationMixin
  ],
  props: {
    label: {
      default: ''
    },
    value: {
      default: ''
    },
    placeholder: {
      default: ''
    },
    autofocus: {
      default: false
    },
    debounce: {
      default: null
    },
    disabled: {
      default: false
    }
  },
  data () {
    return {
      inputValue: ''
    }
  },
  watch: {
    inputValue (pValue, pOldValue) {
      if (pValue !== pOldValue) this.$emit('input', pValue)
    },
    value () {
      this.refreshValues()
    }
  },
  mounted () {
    this.refreshValues()
  },
  methods: {
    blur () {
      this.$emit('blur')
    },
    refreshValues () {
      this.inputValue = this.value
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/cp1-datebox/Datebox.vue